import { BaseContext } from 'types';

const updateState = <T extends BaseContext>(context: T, state?: string) => {
  state && context.internals.setState(JSON.parse(state));
};

export default updateState;
